import React from "react";
import { isEmpty } from "lodash";
import { TableCell } from "@material-ui/core";
import { AlertCircle } from "mdi-material-ui";
import { WithTooltip } from "@components";

type Props = React.ComponentProps<typeof TableCell> & {
  children: React.ReactNode;
  errors?: string[];
};

export function ImportTableCell(props: Props) {
  const { children, errors, ...rest } = props;

  const hasErrors = !isEmpty(errors);

  return (
    <TableCell {...rest}>
      <WithTooltip title={props.errors?.join("\n")}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {hasErrors && (
            <AlertCircle fontSize="small" color="error" style={{ marginRight: 4 }} />
          )}

          <span>{props.children}</span>
        </div>
      </WithTooltip>
    </TableCell>
  );
}
